import React from 'react';

import {
  SkeletonLoaderWrapper,
  SkeletonLoaderLineFull,
  SkeletonLoaderLineHalf,
} from './SkeletonLoader.styles';

export const MFESkeletonLoader = () => {
  return (
    <SkeletonLoaderWrapper>
      <SkeletonLoaderLineHalf />
      <SkeletonLoaderLineFull />
      <SkeletonLoaderLineFull />
    </SkeletonLoaderWrapper>
  );
};

export default MFESkeletonLoader;
